import { breakpoints } from '@/styles/media';
import type { HTMLAttributes } from 'react';
import styled from 'styled-components';

export interface IGridWrapperProps extends HTMLAttributes<HTMLDivElement> {
    spaceVertically?: boolean;
}

/** A container around a collection of `<FlexItem>` components that gives them the correct spacing. */
export const GridWrapper = styled.div<IGridWrapperProps>`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin-left: calc(-1 * var(--size-grid-unit));
    margin-bottom: calc(-1 * var(--size-grid-unit));
    ${({ spaceVertically = true }) =>
        spaceVertically && breakpoints.M`margin-bottom: calc(-1 * var(--size-grid-double));`};
    > * {
        // space out the immediate children (should always be a FlexItem)
        padding: 0 0 var(--size-grid-unit) var(--size-grid-unit);
        ${({ spaceVertically = true }) => spaceVertically && breakpoints.M`padding-bottom: var(--size-grid-double);`};
    }
`;
